class RemindModalController {
  constructor(AuthenticationService, $http, $uibModalInstance, $rootScope, items){
    "ngInject";
    this.items = items;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$uibModalInstance = $uibModalInstance;
  }

  ok(){
    let self = this;
    let timesheetIds = [];

    this.items.forEach( (ts) => {
      timesheetIds.push(ts.id);
    });

    let obj = {
      status: 'REMIND',
      timesheets: timesheetIds,
    };

    self.$http.post(`${self.$rootScope.apiHost}/api/review/timesheets`, obj, {withCredentials: true}).then(function (success) {
      self.$uibModalInstance.close();
      self.$uibModalInstance.success();
    });
  }

  cancel(){
    // TODO: What does that message do?
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default RemindModalController;



// WEBPACK FOOTER //
// ./client/pages/review/modals/remind/controller.js